angular.module('unergie.main')
.directive('userInfoContractPaymentHeader', ($sce, $filter, $window, BoFeaturesService, DataAccess, DataAccessRefVariables, DataAccessSearch, AlertManager, ApiUser, ApiAdmin,
    AdminComments, PaymentService, MetaWatcher, ReferencesService, ErrorCatcher, BarcodeService, AuthService) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractPaymentHeader.html',
        link($scope) {
            const checkOverdue = BoFeaturesService.isFeatureOn('checkOverdue')
            $scope.displayField = BoFeaturesService.fieldTester('accountinfo')
            $scope.adminLink = BoFeaturesService.getModuleFeatures('overdues').adminLink
            $scope.canSeeBillingBalance = BoFeaturesService.isFeatureOn('canSeeBillingBalance')
            $scope.canFillIBAN = BoFeaturesService.isFeatureOn('canFillIBAN')

            // FEATURES
            $scope.isAIFeatureOn = (feature) => BoFeaturesService.getModuleFeatures('accountinfo')[feature]
            $scope.canModifyBillingModality = $scope.isAIFeatureOn('canModifyBillingModality')

            DataAccessRefVariables.getVariables().$promise.then((data) => {
                $scope.overdueThreshold = data.find((v) => v.key === 'OVERDUE_THRESHOLD')
            })

            $scope.spinners = {}

            $scope.chosen = {
                preferredDay: $scope.account.billingaccount.preferred_payment_day,
                sleek_timetable: $scope.account.billingaccount.sleek_timetable,
            }
            $scope.updatePreferredDayMode = false
            $scope.updateSleeking = false
            $scope.booleanChoice = [
                { id: true, label: 'Oui' },
                { id: false, label: 'Non' },
            ]
            $scope.overdueProcess = undefined
            $scope.billingModalityMapping = {
                '2month': 'bimestrielle',
                '6month': 'semestrielle',
                '12month': 'annuelle',
            }

            // Internalize overdue campaign recovery status
            $scope.internalizeSuccess = false

            // REFS
            $scope.preferredDays = []
            ReferencesService.getRef('pref-payment-days').then((mapping) => {
                $scope.preferredDays = _.range(mapping.MIN, mapping.MAX + 1)
            })

            $scope.isAdmin = () => AuthService.userHasGroup(['data-admin'])

            $scope.showContractBalance = () => ($scope.contract.contractBalance.balance < 0) || ($scope.contract.status === 15)

            $scope.toggleUpdatePreferredDayMode = function () {
                $scope.chosen.preferredDay = $scope.account.billingaccount.preferred_payment_day
                $scope.updatePreferredDayMode = !$scope.updatePreferredDayMode
            }

            $scope.saveDay = () =>
                DataAccess.updatePaymentDay({ id_account: $scope.account.id }, { preferredPaymentDay: $scope.chosen.preferredDay }).$promise.then(() => {
                    AlertManager.success('Jour modifié')
                    const comment = `<b>AUTOMATIQUE</b> : Jour de paiement préféré mis à jour : <b>${$scope.chosen.preferredDay}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.toggleUpdatePreferredDayMode()
                    $scope.refreshAccount()
                }).catch(ErrorCatcher)


            $scope.toggleUpdateSleeking = function () {
                $scope.chosen.sleek_timetable = $scope.account.billingaccount.sleek_timetable
                $scope.updateSleeking = !$scope.updateSleeking
            }

            $scope.saveSleek = () => {
                return DataAccess.updateSleeking({ id_account: $scope.account.id }, { sleek_timetable: $scope.chosen.sleek_timetable }).$promise.then(() => {
                    AlertManager.success('Mode de lissage modifié')
                    const comment = `<b>AUTOMATIQUE</b> : Mode de lissage modifié : <b>${$scope.chosen.sleek_timetable}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.toggleUpdateSleeking()
                    $scope.refreshAccount()
                })
                .catch(ErrorCatcher)
            }

            $scope.toggleUpdateBillingModality = function () {
                $scope.chosen.billingModality = $scope.contract.billing_modality
                $scope.updateBillingModality = !$scope.updateBillingModality
            }

            $scope.saveBillingModality = () => {
                const idContract = $scope.contract.id
                const bmLabel = $scope.billingModalityMapping[$scope.chosen.billingModality] || $scope.chosen.billingModality

                return ApiUser.updateBillingModality({ idContract }, {
                    billingModality: $scope.chosen.billingModality,
                })
                .$promise.then((ret) => {
                    const nbd = moment(ret.nextBillableDate)
                    const msg = nbd.isBefore(moment())
                        ? 'Une facture va être éditée au plus tôt.'
                        : `Prochaine facture prévue le ${nbd.format('DD/MM/YYYY')}.`

                    AlertManager.success(`Modalité de facturation modifiée. ${msg}`, 7000)
                    AdminComments.addComment({
                        object: idContract,
                        comment: `<b>AUTOMATIQUE</b> : Modalité de facturation modifiée : <b>${bmLabel}</b>. Prochaine facture prévue le : <b>${nbd.format('DD/MM/YYYY')}</b>.`,
                    })
                    .$promise.catch(ErrorCatcher)

                    $scope.toggleUpdateBillingModality()
                    $scope.refreshAccount()
                })
                .catch(ErrorCatcher)
            }

            // UPDATE RECURRENT CB
            $scope.toggleUpdateRecurrentCb = function () {
                $scope.chosen.recurrent_cb_payment = $scope.account.billingaccount.recurrent_cb_payment
                $scope.updateRecurrentCb = !$scope.updateRecurrentCb
            }

            $scope.saveRecurrentCb = () =>
                DataAccess.updateRecurrentCb({ id_account: $scope.account.id }, { recurrent_cb_payment: $scope.chosen.recurrent_cb_payment }).$promise.then(() => {
                    AlertManager.success('Paiement CB récurrent modifié')
                    $scope.toggleUpdateRecurrentCb()
                    $scope.refreshAccount()
                }).catch(ErrorCatcher)

            $scope.removeCardAlias = () => {
                return DataAccess.removeCardAlias({ id_account: $scope.account.id }).$promise.then(() => {
                    AlertManager.success('Alias de carte bancaire supprimé')
                    $scope.refreshAccount()
                })
                .catch(ErrorCatcher)
            }

            $scope.removeMandate = () => {
                return DataAccess.removeMandate({ id_account: $scope.account.id }).$promise.then(() => {
                    AlertManager.success('Mandat supprimé')
                    $scope.refreshAccount()
                })
                .catch(ErrorCatcher)
            }

            // IBAN
            $scope.ibanFields = {
                iban: {
                    required: true,
                    label: 'IBAN',
                    type: 'iban',
                },
            }

            $scope.ibanPayload = {
                iban: '',
            }

            $scope.modifyingIban = false

            $scope.modifyIban = function () {
                $scope.modifyingIban = true
                return ApiUser.modifyIban({ id_account: $scope.account.id }, { iban: $scope.ibanPayload.iban }).$promise.then(() => {
                    AlertManager.success('IBAN modifié')
                    const start = $scope.ibanPayload.iban.substring(0, 4)
                    const end = $scope.ibanPayload.iban.substring($scope.ibanPayload.iban.length - 4)
                    const comment = `<b>AUTOMATIQUE</b> : IBAN modifié : <b>${start} XX...XX ${end}</b>`
                    AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                    $scope.ibanPayload.iban = ''
                    MetaWatcher.notif('ACCOUNT_CHANGED')
                }).catch(ErrorCatcher)
                .finally(() => {
                    $scope.modifyingIban = false
                })
            }

            $scope.dlMandate = function () {
                $window.open(`/api-user/admin/account/${$scope.account.id}/mandate`, '_blank')
                return true
            }

            $scope.loadBankAccount = () => ApiUser.bankAccount({ id_account: $scope.account.id })

            $scope.ibanFilter = (elem) =>
                `${`<b>IBAN : </b> ${elem.iban}<br>` +
                '<b>BIC : </b> '}${elem.bic}<br>` +
                `<b>Banque : </b> ${elem.institutionName}<br>`


            // DEPOSIT
            const initDepositDuration = (depositDate) => {
                $scope.depositDuration = 0
            }

            $scope.checkDeposit = function () {
                $scope.depositTitle = 'Dépôt de garantie'
                if ($scope.depositDuration > 0) {
                    $scope.depositTitle = `Dépôt de garantie - en attente de validation (${$filter('duration')($scope.depositDuration)})`
                    return true
                }
                return false
            }

            // IBAN
            $scope.ibanMandateFields = {
                iban: {
                    hidden: () => !$scope.canFillIBAN,
                    label: 'IBAN (optionnel, le client peut le remplir chez slimpay)',
                    type: 'iban',
                },
            }

            $scope.ibanMandatePayload = {
                iban: '',
            }

            $scope.signingMandate = false

            $scope.signMandate = () => {
                $scope.signingMandate = true
                const toPost = $scope.ibanMandatePayload.iban ? { iban: $scope.ibanMandatePayload.iban } : {}
                return ApiUser.signNewMandate({ id_account: $scope.account.id }, toPost).$promise.then(() => {
                    AlertManager.success('Email de signature de mandat envoyé')
                    $scope.ibanMandatePayload.iban = ''
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.signingMandate = false
                })
            }

            $scope.createAlias = () => {
                $scope.creatingAlias = true
                return ApiUser.createAlias({ id_account: $scope.account.id }, {}).$promise.then(() => {
                    AlertManager.success(`Email de creation d'un alias de carte bancaire envoyé avec succès`)
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.creatingAlias = false
                })
            }

            // EXISTING OVERDUE PROCESS
            const checkOverdueProcess = function () {
                if (checkOverdue) {
                    DataAccess.activeOverdueProcessOnContract({ id_contract: $scope.contract.id }).$promise.then((processes) => {
                        if (processes.length > 0) {
                            $scope.overdueProcess = processes[0]
                            if ($scope.contract.status === 4 && $scope.contract.overdueRecoveryCampaigns && $scope.contract.overdueRecoveryCampaigns.length === 0
                                && $scope.overdueProcess && $scope.overdueProcess.process_name === 'TerminatedOverdue'
                                && $scope.overdueProcess.status && !$scope.overdueProcess.status.startsWith('CANCELLED_') && !$scope.overdueProcess.status.startsWith('FINISHED_')) {
                                $scope.isAllowedRecovery = true
                            } else {
                                $scope.isAllowedRecovery = false
                            }
                        }
                    })
                    .catch(ErrorCatcher)
                    return DataAccessSearch({}).search({ resource: 'contracts-od-no-process', id: $scope.contract.id }).$promise.then((processes) => {
                        if (processes.length > 0) {
                            $scope.overdueNoProcess = processes[0]
                        }
                    }).catch(ErrorCatcher)
                }
            }

            // LAUNCH OVERDUE PROCESS
            $scope.launching = {}

            $scope.overduePayload = {}

            $scope.overdueFields = {
                start_date: {
                    label: 'Date de 1er impayé',
                    type: 'date',
                },
                bypass: {
                    label: 'Court-circuit',
                    type: 'select',
                    enum: [
                        { label: 'Pas de court-circuit', value: '0' },
                        { label: 'Avant vérification chèque énergie', value: '2' },
                        { label: 'Avant LRAR', value: 'energy_check' },
                        { label: 'Avant limitation/coupure', value: '3' },
                    ],
                },
            }

            $scope.terminatedOverdueFields = {
                start_date: {
                    label: 'Date de paiement la facture',
                    type: 'date',
                },
            }

            $scope.updateOverduePayload = (contract) => {
                $scope.overduePayload = {
                    id_contract: contract.id,
                    start_date: moment().toDate(),
                    bypass: '0',
                }
            }

            $scope.showTerminatedOverdueButton = (overdue) => overdue.status === 4

            $scope.launchOverdue = function () {
                $scope.launching[$scope.overduePayload.id_contract] = true
                const payload = angular.copy($scope.overduePayload)
                payload.start_date = moment(payload.start_date).format('YYYY-MM-DD')
                return ApiUser.startOverdue(payload).$promise.then(() => {
                    AlertManager.success('Processus d\'impayé démarré')
                    const sound = new Audio('/sounds/slap.mp3')
                    sound.play()
                    return $scope.refreshAccount() }).catch(ErrorCatcher)
                .finally(() => {
                    $scope.launching[$scope.overduePayload.id_contract] = false
                })
            }

            $scope.launchTerminatedOverdue = function () {
                $scope.launching[$scope.overduePayload.id_contract] = true
                const payload = angular.copy($scope.overduePayload)
                payload.start_date = moment(payload.start_date).format('YYYY-MM-DD')
                return ApiUser.startTerminatedOverdue(payload).$promise.then(() => {
                    AlertManager.success('Processus d\'impayé post-résiliation démarré')
                    const sound = new Audio('/sounds/slap.mp3')
                    sound.play()
                    return $scope.refreshAccount() }).catch(ErrorCatcher)
                .finally(() => {
                    $scope.launching[$scope.overduePayload.id_contract] = false
                })
            }


            const b = $scope.contract.contractBalance
            if (b) {
                const t = `${`Total dû : ${b.owed} €<br>` +
                'Payé : '}${b.paid} €<br>` +
                `Planifié : ${b.planned} €<br>` +
                `En attente : ${b.pending} €<br>` +
                `Cagnotte utilisée : ${b.burned} €<br>` +
                `A recouvrer : ${b.to_recover} €`
                $scope.balanceTooltip = $sce.trustAsHtml(t)
            }

            // DEPOSIT BURN
            $scope.depositBurning = false
            $scope.depositBurnPayload = PaymentService.depositBurnPayload()
            $scope.depositBurnFields = PaymentService.depositBurnFields()

            $scope.canReimburseDeposit = () => PaymentService.canReimburseDeposit($scope.contract)

            $scope.canBurnDeposit = () => PaymentService.canBurnDeposit($scope.contract)

            $scope.depositBurn = () =>
                PaymentService.depositBurn($scope.contract, $scope.depositBurnPayload, $scope.spinners).then(() => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract))

            $scope.reimburseDeposit = () =>
                PaymentService.reimburseDeposit($scope.contract, $scope.reimbursingDeposit).then(() => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract))


            const mandateRevokation = function (value) {
                $scope.revoking = true
                return DataAccess.mandateRevokation({ id_account: $scope.contract.id_account, value }, {}).$promise.then(() => {
                    const msg = value ? 'Mandate révoqué' : 'Révocation levée'
                    AdminComments.addComment({ object: $scope.account.customer_id, comment: `<b>AUTOMATIQUE</b> : ${msg}` }).$promise.catch(ErrorCatcher)
                    AlertManager.success(msg)
                    MetaWatcher.notif('ACCOUNT_CHANGED')
                }).catch(ErrorCatcher)
                .finally(() => {
                    $scope.revoking = false
                })
            }

            // REVOKE / UNREVOKE
            $scope.revokeFields = {
                info: {
                    type: 'label',
                    label: 'Le mandat a été révoqué par le client ou sa banque. Cliquer ici pour confirmer l\'arrêt des prélèvements.',
                },
            }

            $scope.unrevokeFields = {
                info: {
                    type: 'label',
                    label: 'Le mandat de paiement a été renouvelé. Cliquer ici pour reprendre les prélèvements.',
                },
            }

            $scope.revoke = () => mandateRevokation(true)

            $scope.unRevoke = () => mandateRevokation(false)

            $scope.paidRate = (contractBalance) => {
                const { paid, burned, owed } = contractBalance
                return contractBalance.owed === 0 ? (0).toFixed(2) : (((paid + burned) / owed) * 100).toFixed(2)
            }

            $scope.internalizeOverdueRecovery = () => {
                if ($scope.isAllowedRecovery) {
                    DataAccess.internalizeOverdueRecovery({ id_contract: $scope.contract.id }).$promise.then((result) => {
                        $scope.isAllowedRecovery = false
                        AlertManager.success(`Le contrat ${$scope.contract.id} a bien été internalisé chez Plüm`)
                    }, (error) => {
                        $scope.internalizeSuccess = true
                        $scope.isAllowedRecovery = true
                    })
                }
            }

            $scope.hasCBExpired = () => {
                return moment($scope.account.billingaccount.alias_expiration).isBefore(moment())
            }

            $scope.fetchOdooBalance = () => {
                return ApiAdmin.getContractOdooBalance({ id_contract: $scope.currentContract.id }).$promise
                .then((odooBalance) => {
                    return `Balance odoo : ${_.get(odooBalance, '0.data.balance')} €`
                })
                .catch(ErrorCatcher)
            }

            // ACTIVATE
            const activate = function () {
                checkOverdueProcess()
                return $scope.$watch('contract.depositDate', initDepositDuration)
            }

            return activate()
        },
    })
)
